exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---vT6nF{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;border-radius:1rem;border:.3rem solid #000;padding:1rem 2rem;display:flex;flex-direction:column;align-items:center}.close---1TTQ0{align-self:flex-end;margin:.5rem 0;cursor:pointer;transform:translate(.5rem,-.5rem)}.band---1my3s,.eqBands---NjMLY{display:flex}.band---1my3s{flex-direction:column;align-items:center}.band---1my3s input{width:5rem;-webkit-appearance:slider-vertical}.eqReset---2fA0i{margin-top:1rem;padding:.2rem .3rem}.echo---1zpEB{margin-top:2.5rem;margin-bottom:1rem}.echo---1zpEB :not(:first-child){margin-left:2rem}.echo---1zpEB p{display:inline-block;width:1.5rem}.echoReset---HNfxB{padding:.2rem .3rem}", ""]);

// Exports
exports.locals = {
	"root": "root---vT6nF",
	"close": "close---1TTQ0",
	"band": "band---1my3s",
	"eqBands": "eqBands---NjMLY",
	"eqReset": "eqReset---2fA0i",
	"echo": "echo---1zpEB",
	"echoReset": "echoReset---HNfxB"
};